import request from "@/api/request";

class Company {
  getCompany() {
    return request({
      url: "/api/company",
      method: "post"
    });
  }

  getCustomer(data) {
    return request({
      url: "/api/company/customer",
      method: "post",
      data: data
    });
  }
}

export default new Company();
